import { enableProdMode } from '@angular/core';

import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi
} from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideClientBootstrap } from './app/core/client-bootstrap';
import { AuthGuard } from './app/features/auth/guards';
import { CurrentCultureInterceptor } from './app/core/interceptors/current-culture.interceptor';
import { HttpErrorInterceptor } from './app/core/interceptors/http-error.interceptor';
import { AuthInterceptor } from './app/features/auth/interceptors';
import { ChangesNotSavedGuard } from './app/shared/components/changes-not-saved';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

export class TranslocoHttpLoader {
    async getTranslation(lang: string) {
        const res = await import(`./assets/i18n/${lang}.json`);
        return res.default;
    }
}

bootstrapApplication(AppComponent, {
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        provideTransloco({
            config: {
                availableLangs: ['en', 'es'],
                defaultLang: 'en',
                fallbackLang: 'en',
                reRenderOnLangChange: true,
                prodMode: environment.production
            },
            loader: TranslocoHttpLoader
        }),
        ChangesNotSavedGuard,
        AuthGuard,
        provideNativeDateAdapter(),
        provideRouter(routes),
        // Must come after provideRouter (it injects UrlSerializer) — resolves the client
        // code and loads the client before any component can read runtimeConfig.clientId.
        provideClientBootstrap(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CurrentCultureInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ]
});
